export const URL = 'http://www3.kanal.co.jp/mvt'
// export const URL = 'http://192.168.1.169:8080'
// export const URL = 'http://133.242.166.193/mvt'
// export const URL = 'http://www.shiteidourozu.city.nagoya.jp/mvt'
// export const URL = 'https://www.shiteidourozu.city.nagoya.jp/mvt'
